import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-status-badge>` displays a small circle badge used to indicate a specific status.
 *
 *  Ideally should be used with the `labsStatusColor` directive.
 */
@Component({
  selector: 'labs-status-badge',
  template: '',
  styleUrls: ['status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusBadgeComponent {}
